// Local UI fixture only. These identifiers are synthetic and are never sent to Nexi.
export const legacyTestContractDemo = {
    id: 'legacy-test-contract-demo',
    athleteName: 'Atleta Demo',
    categoryName: 'Contratto Nexi di test (legacy)',
    amount: 580,
    paidAmount: 193.33,
    status: 'partialPayment',
    paymentMethod: 'nexiRates',
    installments: [
        {
            number: 1,
            amount: 193.33,
            status: 'completed',
            scheduledDate: '2026-07-15T18:41:00Z',
            paidAt: '2026-07-15T18:41:00Z',
            nextRetryAt: null,
            errorMessage: null,
            attempts: [
                {
                    id: 'demo-attempt-1',
                    status: 'completed',
                    errorMessage: null,
                    transactionId: 'DEMOFIRSTINSTALLMENT',
                    historical: true,
                    attemptedAt: '2026-07-15T18:41:00Z',
                    completedAt: '2026-07-15T18:41:00Z',
                    nextRetryAt: null,
                },
            ],
        },
        {
            number: 2,
            amount: 193.33,
            status: 'failed',
            scheduledDate: '2026-10-01T12:00:00Z',
            paidAt: null,
            nextRetryAt: '2026-10-01T12:00:00Z',
            errorMessage: 'Ordine doppio: il vecchio contratto ha riutilizzato un codice transazione già presente.',
            attempts: [
                {
                    id: 'demo-attempt-3',
                    status: 'failed',
                    errorMessage: 'Ordine doppio: codice transazione già utilizzato.',
                    transactionId: 'DEMORETRY02',
                    historical: true,
                    attemptedAt: '2026-09-29T12:00:00Z',
                    completedAt: null,
                    nextRetryAt: '2026-10-01T12:00:00Z',
                },
                {
                    id: 'demo-attempt-2',
                    status: 'failed',
                    errorMessage: 'Ordine doppio: codice transazione già utilizzato.',
                    transactionId: 'DEMORETRY01',
                    historical: true,
                    attemptedAt: '2026-09-28T12:00:00Z',
                    completedAt: null,
                    nextRetryAt: '2026-09-29T12:00:00Z',
                },
            ],
        },
        {
            number: 3,
            amount: 193.34,
            status: 'pending',
            scheduledDate: '2026-10-15T12:00:00Z',
            paidAt: null,
            nextRetryAt: '2026-10-15T12:00:00Z',
            errorMessage: null,
            attempts: [],
        },
    ],
};
